import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { enableProdMode, EnvironmentProviders, importProvidersFrom, Provider, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApmErrorHandler, ApmModule } from '@elastic/apm-rum-angular';
import { registerAgGrid } from '@hs/ui-core-datagrid-advanced';

import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { httpErrorInterceptor } from './app/interceptors/http-error//http-error.interceptor';
import { initiatorHeaderInterceptor } from './app/interceptors/initiator-header/initiator-header.interceptor';
import { VersionService } from './app/services/version.service';
import { WINDOW } from './app/window';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

registerAgGrid();

const providers: (Provider | EnvironmentProviders)[] = [
    provideZoneChangeDetection(),
    importProvidersFrom(
        ApmModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        BrowserModule,
    ),
    { provide: WINDOW, useValue: window },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    ApmErrorHandler,
    VersionService,
    provideHttpClient(withInterceptors([httpErrorInterceptor, initiatorHeaderInterceptor])),
];

bootstrapApplication(AppComponent, { providers }).catch((err) => console.error(err));
